import { ModalTemplateProps, modal } from '@ardoq/modal';
import { DeleteAssetDialog } from './DeleteAssetDialog';
import { DeleteAssetProps } from './types';
import { type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { getCurrentLocale, type Locale } from '@ardoq/locale';

export const confirmDeleteAsset = (
  confirmDialogConfig: DeleteAssetProps &
    Pick<ModalTemplateProps, 'inputDataTestId'> & {
      locale?: Locale;
      i18nLocale?: I18nLocale;
    }
) => {
  const {
    // getCurrentLocale() / i18nLocale$.state OK here: snapshot-at-open-time; @ardoq/modal renders the confirm() body once and does not re-render on locale change.
    // These are default args for legacy callers that haven't been migrated to thread locale. Reading once at the imperative modal-open boundary lets the deep
    // AffectedEntitiesTable render purely from its `locale` prop instead of reaching for the global on every row.
    // oxlint-disable-next-line ardoq-lint/no-get-current-locale -- one-shot snapshot at the imperative confirm() boundary
    locale = getCurrentLocale(),
    i18nLocale = i18nLocale$.state,
    ...dialogConfig
  } = confirmDialogConfig;
  return modal<boolean>(resolve => (
    <DeleteAssetDialog
      {...dialogConfig}
      locale={locale}
      i18nLocale={i18nLocale}
      onConfirm={() => resolve(true)}
      onCancel={() => resolve(false)}
    />
  ));
};
